// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner-module__spinner___r3H0z","spin":"Spinner-module__spin___kRr3j","spinner_hidden":"Spinner-module__spinner_hidden___UXdkl"};